import {request} from "../../Base/HTTP";
import HttpMethod from "../../Constants/Base/HttpMethod";

export async function getCalendarData(data) {
    return await request('/api/calendar/data', data);
}